import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { Center } from '@/types'

/**
 * 認證狀態管理 Store
 */
export const useAuthStore = defineStore('auth', () => {
  // State
  const accessToken = ref<string | null>(localStorage.getItem('access_token'))
  const currentUser = ref<string | null>(null)
  const currentName = ref<string | null>(null)
  const currentUserId = ref<number | null>(null)
  const userCenters = ref<Center[]>([])

  // Getters
  const isAuthenticated = computed(() => !!accessToken.value)
  const isAdmin = computed(() => currentUser.value === 'admin')

  // Actions
  function setAuth(token: string, user: string, name: string) {
    accessToken.value = token
    currentUser.value = user
    currentName.value = name
    localStorage.setItem('access_token', token)
  }

  function clearAuth() {
    accessToken.value = null
    currentUser.value = null
    currentName.value = null
    currentUserId.value = null
    localStorage.removeItem('access_token')
  }

  function setUserInfo(user: string, name: string, userId?: number) {
    currentUser.value = user
    currentName.value = name
    if (userId !== undefined) {
      currentUserId.value = userId
    }
  }

  function setUserId(userId: number) {
    currentUserId.value = userId
  }

  function setUserCenters(centers: Center[]) {
    userCenters.value = centers
  }

  return {
    // State
    accessToken,
    currentUser,
    currentName,
    currentUserId,
    // Getters
    isAuthenticated,
    isAdmin,
    // Actions
    setAuth,
    clearAuth,
    setUserInfo,
    setUserId,
    setUserCenters,
    userCenters
  }
})
